/****************************************************
 * Module Name:  addRapnetloginsModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import { Form, Modal } from "react-bootstrap";
import { LoadingButton } from "@mui/lab";
import { Box, Button, Checkbox, FormControlLabel, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import logo from '../../images/pansuriya.jpg'
import Utility from "../../utility/utility";
import RapnetLoginsProxy from "../../utility/proxy/manager/rapnetLoginsProxy";
import SaveIcon from '@mui/icons-material/Save';

export default class AddRapnetloginsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newRapnetid: this.props.editOperation ? this.props.sourceData.rapnetid : "",
      newRapnetClientId: this.props.editOperation ? this.props.sourceData.clientid : "",
      newRapnetClientSecret: this.props.editOperation ? this.props.sourceData.clientsecret : "",
      newRapnetDescription: this.props.editOperation ? this.props.sourceData.description : "",
      newRapnetMemberComment: this.props.editOperation ? this.props.sourceData.membercomment : "",
      newRapnetdisable: this.props.editOperation ? this.props.sourceData.disable : false,

      showError: false,
      idAvailable: this.props.editOperation,
      showValidationMessage: false,
      validateRapnetIdPresentSpinner: false,

      rapnetIdValidationError: "",
    }
  }

  handleSave = () => {
    let data = {
      rapnetid: this.state.newRapnetid,
      clientid: this.state.newRapnetClientId,
      clientsecret: this.state.newRapnetClientSecret,
      description: this.state.newRapnetDescription,
      membercomment: this.state.newRapnetMemberComment,
      disable: this.state.newRapnetdisable,
    }

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) {
          this.props.handleSave(data);
        }
        else {
          this.setState({
            showError: true,
          });
        }
      } else this.props.handleSave(data);
    }
  }

  validateRapnetIdPresent = (idEntered) => {
    if (!idEntered || idEntered.trim() === "") return;

    this.setState({
      validateRapnetIdPresentSpinner: true,
    });

    RapnetLoginsProxy.CheckRapnetIdAvailable(idEntered, (response) => {
      //if we got response that means rapnet login id is present at backend
      if (response) {
        //rapnet login id already present
        this.setState({
          validateRapnetIdPresentSpinner: false,
          showValidationMessage: true,
          idAvailable: false,
        });
      } else {
        //rapnet login id not available, so can be used
        this.setState({
          validateRapnetIdPresentSpinner: false,
          showValidationMessage: true,
          idAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    return (
      this.state.newRapnetid === null || this.state.newRapnetid.trim() === "" ||
      this.state.newRapnetClientId === null || this.state.newRapnetClientId.trim() === "" ||
      this.state.newRapnetClientSecret === null || this.state.newRapnetClientSecret.trim() === ""
    )
  }

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add Rapnet login validation Failed
              <br />Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />
        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Rapnet Login" : "Add Rapnet Login"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation ? (
                    <tr>
                      <td>
                        <Form.Label>Rapnet Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.rapnetid}</Form.Label>
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td>
                        <Form.Label>
                          Rapnet Id <sup style={{ color: "red" }}>*</sup>
                        </Form.Label>
                      </td>
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          autoFocus
                          label="Rapnet Id (required)"
                          placeholder="Enter Rapnet Id"
                          value={this.state.newRapnetid}
                          onBlur={(e) =>
                            this.validateRapnetIdPresent(this.state.newRapnetid)
                          }
                          onChange={(e) =>
                            this.setState({
                              newRapnetid: e.target.value,
                              showValidationMessage: false,
                              rapnetIdValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Rapnet Id Cannot be Empty",
                            })
                          }
                          helperText={this.state.rapnetIdValidationError}
                          error={this.state.rapnetIdValidationError}
                        />
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      {this.state.validateRapnetIdPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.idAvailable ? (
                        <font color="green">Rapnet Login Id is available</font>
                      ) : (
                        <font color="red">Rapnet Login Id is not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Client Id <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Rapnet Client Id (required)"
                        placeholder="Enter Rapnet Client Id"
                        value={this.state.newRapnetClientId}
                        onChange={(e) =>
                          this.setState({
                            newRapnetClientId: e.target.value,
                          })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Client Secret <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Rapnet Client Secret (required)"
                        placeholder="Enter Rapnet Client Secret"
                        value={this.state.newRapnetClientSecret}
                        onChange={(e) =>
                          this.setState({
                            newRapnetClientSecret: e.target.value,
                          })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Description
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Rapnet Description"
                        placeholder="Enter Rapnet Description"
                        value={this.state.newRapnetDescription}
                        onChange={(e) =>
                          this.setState({
                            newRapnetDescription: e.target.value,
                          })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Member Comment
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Member Comment"
                        placeholder="Enter Member Comment"
                        value={this.state.newRapnetMemberComment}
                        onChange={(e) =>
                          this.setState({
                            newRapnetMemberComment: e.target.value,
                          })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>&nbsp;</Form.Label>
                    </td>
                    <td>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.newRapnetdisable}
                            onChange={(e) =>
                              this.setState({
                                newRapnetdisable: !this.state.newRapnetdisable,
                              })
                            }
                          />
                        }
                        label="Disabled"
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            fontSize: "0.8rem",
                          },
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            {this.props.saveButton ? (
              <LoadingButton
                loading={this.props.loading}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
                onClick={() => this.handleSave()}
                disabled={this.buttonDisable()}
                sx={{ mr: 1 }}
              >
                Save
              </LoadingButton>
            ) : null}
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    )
  }
}